import { createVariant } from '../../utils/createVariant';
export const CounterNumber = createVariant({
    name: 'counter-number',
    tagName: 'span',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, theme.typography.numbersPricesAndUsPs['800CounterNumber']), { color: theme.colors.base.textCounter, display: 'inline-block' })),
});
//# sourceMappingURL=CounterNumber.js.map